import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {Deltakerstatus, MøtedeltakerModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('MøteDeltakereStatusKomponent');

@Component({
    selector: 'moete-deltakere-status',
    templateUrl: 'møte-deltakere-status.html',
    styleUrl: 'møte-deltakere-status.scss',
    imports: [
        ReactiveFormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatSlideToggleModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteDeltakereStatusKomponent {

    deltakere = input.required<MøtedeltakerModell[]>();

    antallDeltakere = computed<number>(() => this.deltakere().length);
    antallIkkeSendt = computed<number>(() => this.deltakere().filter(deltaker => deltaker.status === Deltakerstatus.innkalling_ikke_sendt).length);
    antallGodtatt = computed<number>(() => this.deltakere().filter(deltaker => deltaker.status === Deltakerstatus.akseptert).length);
    antallAvslaatt = computed<number>(() => this.deltakere().filter(deltaker => deltaker.status === Deltakerstatus.avslaatt).length);
    antallSendt = computed<number>(() => this.deltakere().filter(deltaker => deltaker.status === Deltakerstatus.innkalling_sendt).length);
    antallInvitasjonSendtEllerGodtattEllerAvslaatt = computed<number>(() => this.antallSendt() + this.antallGodtatt() + this.antallAvslaatt());

    // {{antallDeltakere}} deltaker - Innkalling ikke sendt
    visInnkallingIkkeSendtTilNoen = computed<boolean>(() => this.antallDeltakere() === this.antallIkkeSendt());

    // {{antallDeltakere}} deltaker - {{antallinvitasjonsendtellergodtattavslaatt}} innkalt
    visInnkallingIkkeSendtTilAlle = computed<boolean>(() => !this.visInnkallingIkkeSendtTilNoen() && this.antallIkkeSendt() > 0);

    // {{antallDeltakere}} deltaker - {{antallgodtatt}} godtatt
    // alle har fått innkalling og ( (0 har godtatt og 0 har avslått) eller (mer enn 1 har godtatt))
    visInnkallingSendt = computed<boolean>(() => !this.visInnkallingIkkeSendtTilNoen() && !this.visInnkallingIkkeSendtTilAlle() && !this.visInnkallingSendtBareAvslaatte());

    // {{antallDeltakere}} deltaker - {{antallavslaatt}} avslått
    visInnkallingSendtBareAvslaatte = computed<boolean>(() =>
      !this.visInnkallingIkkeSendtTilNoen()
      && !this.visInnkallingIkkeSendtTilAlle()
      && this.antallGodtatt() === 0
      && this.antallAvslaatt() > 0);


    constructor() {
    }

}
